import { Remove } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';

export const RemoveExerciseButton = (props: { setShowDeleteModal: (show: boolean) => void }) => {
  const { setShowDeleteModal } = props;
  return (
    <Tooltip title="Remove Exercise from Deck">
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          setShowDeleteModal(true);
        }}
      >
        <Remove />
      </IconButton>
    </Tooltip>
  );
};
